<template>
  <div id="app">
    <v-fs-card
      v-for="(portfolio, index) in portfolioItems"
      :key="index"
      :portfolio="portfolio"
    ></v-fs-card>
  </div>
</template>

<script>
import Card from "./portfolioComponents/Card.vue";
export default {
  components: {
    "v-fs-card": Card
  },
  computed: {
    portfolioItems() {
      return this.$store.getters["wordpressRest/getPortfolioData"];
    }
  },

  created() {
    this.$store.dispatch("wordpressRest/getPortfolio");
  }
};
</script>

<style>
#app {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.ukraine-support a {
  display: flex;
  flex-direction: row-reverse;
  gap: 6px;
  color: #000 !important;
  cursor: default;
  font-size: 10px !important;
}

.ukraine-support a:hover {
  background-color: #fff !important;
  color: #000 !important;
}

.customButton {
  padding: 70px;
  font-size: 26px;
  font-weight: 400 !important;
}

.fusion-header.fusion-sticky-shadow {
  max-height: 100px;
}

.fusion-logo img {
  max-width: 140px;
}

#dostepnosc {
  z-index: 4;
  position: relative;
}

#portfolio {
  z-index: 5;
  position: relative;
}

.fusion-fullwidth .fusion-row {
  z-index: 0;
}

.visibility-index {
  z-index: 2 !important;
  display: none;
  opacity: 0;
  transition: all 0.2s;
}

.visibility-only-z-index {
  z-index: 2 !important;
}

.table-1 table tr td,
.table-1 table th {
  border: 0px solid rgba(0, 0, 0, 0);
  color: #000;
}

.o-nas {
  z-index: 0 !important;
}

#mapa .google-map {
  height: 500px;
}

#portfolio .fusion-builder-row {
  background: rgba(255, 255, 255, 0.7);
}

#portfolio {
  background-image: url("/wp-content/uploads/2018/06/portfolio.jpg");
  background-attachment: fixed;
  margin: 0px !important;
  padding: 0 !important;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
}

#dostepnosc h2 {
  color: #005500;
  text-align: center;
}

#dostepnosc h2 span {
  border-bottom: 2px solid #333;
}

#dostepnosc {
  background-image: url("/wp-content/uploads/2018/06/dostepnosc.jpg");
  background-attachment: fixed;
  margin: 0px !important;
  padding: 0 !important;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
}

.o-nas {
  background-image: url("/wp-content/uploads/2018/06/onas.jpg");
  background-attachment: fixed;
  margin: 0px !important;
  padding: 0 !important;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
}

.kontakt {
  background-image: url("/wp-content/uploads/2018/06/kontakt.jpg");
  background-attachment: fixed;
  margin: 0px !important;
  padding: 0 !important;
  width: 100%;
  z-index: 0;
  height: 100%;
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
}

#main {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.slider-indicator-icon {
  background-color: #fff !important;
}

.slider-indicator-active {
  background-color: #ec8900 !important;
}

.slider-icon {
  border-left: 0px solid #ec8900 !important;
  border-bottom: 0px solid #ec8900 !important;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  height: auto !important;
  width: auto !important;
  transform: none !important;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 39%,
    rgba(255, 255, 255, 0) 76%,
    rgba(255, 255, 255, 0) 100%
  );
}

.slider-icon-right:before {
  content: "\f138";
  color: #ec8900;
  font-size: 30px;
}

.slider-icon-left:before {
  content: "\f137";
  color: #ec8900;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/Portfolio.vue